import type { Country } from '../country';
import { getPhoneNumberNormalizerWithLength } from '@tectonics/commons/customer-form/get-phone-number-normalizer';

const ARGENTINA: Country = {
  code: 'ar',
  termsAndConditionsUrl: 'https://www.ebanx.com/pt-br/legal/consumidores/argentina/terminos-y-condiciones-generales-argentina/',
  customerForm: {
    phoneNumber: {
      normalizer: getPhoneNumberNormalizerWithLength(20),
    },
  },
};

export default ARGENTINA;
